<template>
	<div>
		<el-dialog title="模板文件列表" :visible.sync="tempDialogShow" width="80%">
			<el-table
				ref="templateList"
				:data="templateList"
				style="width: 100%;margin-bottom: 20px;"
				row-key="ktid"
				:stripe="true"
				tooltip-effect="dark"
			>
				<el-table-column label="" width="40">
					<template slot-scope="scope">
						<el-radio
							:label="scope.$index"
							@change.native="chooseCurrentTemplate(scope.row)"
							style="color: #fff;padding-left: 10px; margin-right: -25px;"
						></el-radio>
					</template>
				</el-table-column>
				<el-table-column prop="" label="模板文件名">
					<template slot-scope="scope">
						{{ scope.row }}
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	export default{
		name:'',
		data(){
			return {
				templateList:[],//模板文件列表
				tempDialogShow:false,
				firstOpen:true
			}
		},
		props:{
			theme_type:{
				type:String,
				default:'web_theme'
			}
		},
		watch:{
			theme_type(){
				this.getTemplateList();
			}
		},
		mounted(){
			this.getTemplateList();
		},
		methods:{
			show(){
				this.tempDialogShow = true;
				// if(this.firstOpen){
				// 	this.getTemplateList();
				// 	this.firstOpen = false;
				// }
			},
			// 获取模型列表
			getTemplateList(){
				this.$axios({
					url: this.HOST + '/admin.document/templatePageList',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						file_dir:this.theme_type
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'userinfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.templateList = res.data;
						}
					})
					.catch(err => {});
			},
			// 选择页面模板
			chooseCurrentTemplate(e) {
				let pagename = e.split('.')[0];
				this.$emit('confirm',pagename);
				this.tempDialogShow = false;
			},
		}
		
	}
</script>
<style>
	
</style>
